@if (hideButton===false) {
  <div class="grid">
    @for (btntool of btnToolList; track btntool.key) {
        <btntool [btnTool]="btntool" (clickButton)="onClickButton($event)"></btntool>
    }
  </div>
}